import { Switch, Redirect } from 'react-router-dom';
import { RouteWithLayout } from '../components';
import { Main as MainLayout } from 'layouts';
import {
  NotFound as NotFoundView,
  Home as HomeView,
  Signup,
  VerifyEmail,
  ConfirmEmail,
  VerificaUsuario,
  VerificaUsuarioSucursal,
  CodigosLer,
  RegistroDonacion
} from 'views';
import SubirCertificadoRecepcion from 'views/Residuos/views/SubirCertificadoReceipcion';
import { RUTAS } from 'const/Rutas';
import { MensajeSolicitarIniciarSesion } from 'views/ConfirmarAdministracion/components/MensajeSolicitarIniciarSesion';
import { ConfirmarRegistroAdministracion } from 'views/ConfirmarRegistroAdministracion/ConfirmarRegistroAdministracion';
import { TerminosYCondiciones } from 'views/TerminosYCondiciones/TerminosYCondiciones';
import { PoliticasPrivacidad } from 'views/TerminosYCondiciones/PoliticasPrivacidad';
import { ConsentimientoDatos } from 'views/TerminosYCondiciones/ConsetimientoDatos';

export const RutasPublicas = () => {
  return (
    // Rutas publicas para usuarios no logueados
    <Switch>
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MainLayout}
        path={RUTAS.NOT_FOUND}
      />
      <RouteWithLayout
        component={HomeView}
        exact
        layout={MainLayout}
        path={RUTAS.HOME}
      />
      {/* REGISTRARSE */}
      <RouteWithLayout
        component={Signup}
        exact
        layout={MainLayout}
        path={RUTAS.REGISTRARSE}
      />
      <RouteWithLayout
        component={VerifyEmail}
        exact
        layout={MainLayout}
        path={RUTAS.REGISTRARSE_VERIFICAR_EMAIL}
      />
      {/* /verifica-cuenta */}
      <RouteWithLayout
        component={ConfirmEmail}
        exact
        layout={MainLayout}
        path={RUTAS.VERIFICAR_CUENTA}
      />
      {/* /verifica-usuario */}
      <RouteWithLayout
        component={VerificaUsuario}
        exact
        layout={MainLayout}
        path={RUTAS.VERIFICAR_USUARIO}
      />
      {/* /verifica-usuario-sucursal */}
      <RouteWithLayout
        component={VerificaUsuarioSucursal}
        exact
        layout={MainLayout}
        path={RUTAS.VERIFICAR_USUARIO_SUCURSAL}
      />

      {/* /subir-certificado */}
      <RouteWithLayout
        component={SubirCertificadoRecepcion}
        exact
        layout={MainLayout}
        path={RUTAS.SUBIR_CERTIFICADO}
      />

      {/* /conceder-administracion */}
      <RouteWithLayout
        component={MensajeSolicitarIniciarSesion}
        exact
        layout={MainLayout}
        path={RUTAS.CONFIRMAR_ADMINISTRACION}
      />

      <RouteWithLayout
        component={ConfirmarRegistroAdministracion}
        exact
        layout={MainLayout}
        path={RUTAS.CONFIRMAR_REGISTRO_ADMINISTRACION}
      />

      <RouteWithLayout
        component={TerminosYCondiciones}
        exact
        layout={MainLayout}
        path={RUTAS.TERMINOS_Y_CONDICIONES}
      />

      <RouteWithLayout
        component={PoliticasPrivacidad}
        exact
        layout={MainLayout}
        path={RUTAS.POLITICAS_PRIVACIDAD}
      />

      <RouteWithLayout
        component={ConsentimientoDatos}
        exact
        layout={MainLayout}
        path={RUTAS.CONSENTIMIENTO_DATOS}
      />

      <RouteWithLayout
        component={() => <h1>403</h1>}
        exact
        layout={MainLayout}
        path={RUTAS.NOT_ALLOWED}
      />

      {/* codigosLer */}
      <RouteWithLayout
        component={CodigosLer}
        exact
        layout={MainLayout}
        path={RUTAS.CODIGOS_LER}
      />

      {/* Formulario donacion WOM */}
      <RouteWithLayout
        component={RegistroDonacion}
        exact
        layout={MainLayout}
        path={RUTAS.REGISTRO_DONACION}
      />
      <Redirect to={RUTAS.HOME} />
    </Switch>
  );
};
